export const routes = {
  home: '/',
  signin: '/signin',
  signout: '/signout',
  users: '/users',
  matches: '/matches',
  prediction: '/prediction',
  predictionResult: '/prediction-result',
  teams: '/teams',
  players: '/players',
  wc2026Teams: '/wc2026-teams',
  wc2026Players: '/wc2026-players',
  wc2026Results: '/wc2026-results',
  settings: '/settings',
  whitelist: '/whitelist',
  lotteries: '/lotteries',
  lotteryPredictions: '/lottery-predictions'
};
